import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { WrapBanner, WrapBannerMobile } from "./style";
import IconNext from "../../assets/icons/icNext.svg";
import IconPrev from "../../assets/icons/icPrev.svg";
import { useMediaQuery } from "@material-ui/core";
import { isEmpty } from "lodash";
import { EmptyState } from "..";

const BannerSliderComponent = (props) => {
	const BASE_URL = process.env.REACT_APP_BASE_URL;
	const { banners } = props;
	const isMobile = useMediaQuery("(max-width:500px)");
	function NextArrow(props) {
		return (
			<div onClick={props.onClick} className="arrow-right">
				<img src={IconNext} alt="next" />
			</div>
		);
	}

	function PrevArrow(props) {
		return (
			<div onClick={props.onClick} className="arrow-left">
				<img src={IconPrev} alt="next" />
			</div>
		);
	}
	const settings = {
		className: "slider variable-width",
		dots: true,
		infinite: true,
		centerMode: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
	};

	const _mappingItemBannerDesktop = () =>
		banners.map((banner, key) => (
			<div className="image" style={{ width: 726 }} key={key}>
				<a
					href={banner ? banner.link : ""}
					target="_blank"
					rel="noreferrer"
					style={{ textDecoration: "none", color: "black" }}
				>
					<img src={banner.image} alt="banner" />
				</a>
			</div>
		));

	const _mappingItemBannerMobile = () =>
		banners.map((banner, key) => (
			<div className="image" key={key}>
				<img src={banner.image} alt="banner" />
			</div>
		));

	const _Desktop = () => (
		<WrapBanner>
			{isEmpty(banners) ? (
				<EmptyState desc="Banner belum disetting" title="Banner tidak ada" />
			) : (
				<Slider {...settings}>{_mappingItemBannerDesktop()}</Slider>
			)}
		</WrapBanner>
	);

	const settingsMobile = {
		dots: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	};

	const _Mobile = () => (
		<WrapBannerMobile>
			{isEmpty(banners) ? (
				<EmptyState desc="Banner belum disetting" title="Banner tidak ada" />
			) : (
				<Slider {...settingsMobile} >{_mappingItemBannerMobile()}</Slider>
			)}
		</WrapBannerMobile>
	);
	return isMobile ? _Mobile() : _Desktop();
};

export default BannerSliderComponent;
